import { render, staticRenderFns } from "./contextMenuItem.vue?vue&type=template&id=787c21d4&"
import script from "./contextMenuItem.js?vue&type=script&lang=js&"
export * from "./contextMenuItem.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports